<app-programtitle title="Discount calculator"></app-programtitle>
<p> Write a program to calculate discount for students and for products on-sale.</p>
<p> This program illustrates a key design pattern called 'Strategy'. </p>

<app-editor code="{{program}}"> </app-editor>